module.exports = __webpack_public_path__ + "img/nu.d7b5488a.svg";